<template>
  <div class="table_form">
    <section>
      <img :src="obj.user_avatar" alt="" />
      <div>
        <b>{{ obj.name }}</b>
        <p>
          <span>兼职号：{{obj.jz_number}}</span>
        </p>
      </div>
    </section>
    <el-button type="primary" @click="invite">邀请</el-button>
  </div>
</template>
<script>
// 
export default {
  props: {
    obj: {
      type: Object,
      default: {
          name:'',
          user_avatar:'',
          user_app_id:'',
          jz_number:'',
        }
    },
  },
  data () {
    return {

    }
  },
  created () { },
  mounted () { 


  },
  methods: {
    invite(){
      var that=this;
      that.$emit("invite")  ;     
    }
    
  }
  // 应用组件

};
</script>
<style lang="scss" scoped>
.table_form {
  width: 100%;
  height: 68px;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid #cccccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-bottom: 19px;
  section {
    display: flex;
    img {
      width: 43px;
      height: 43px;
      margin-right: 15px;
    }
    div {
      height: 43px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      b {
        font-size: 16px;
        color: #333;
      }
      span {
        font-size: 11px;
        margin-right: 20px;
        color: #666;
      }
    }
  }
}
</style>